import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';
import { formatPhoneNumber } from '../../../Utils/phoneUtils';


export default function MemberStatusListTable(props) {
  const {
    members,
    memberType,
    accentColor,
    accentColorHover,
    onClickMember,
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, languageMode } = useLanguage();

  const isRegisteredTab = memberType !== 'churned';

  // 전화번호 포맷 //
  function calcPhone(data) {
    if (!data.phone || data.phone === '') return t('statistics.noPhone');
    return formatPhoneNumber(data.phone, data.countryCode, languageMode) || t('statistics.noPhone');
  }

  // ISO 날짜 포맷 //
  function formatIsoDate(iso) {
    if (!iso) return '';
    const parts = iso.split('T')[0].split('-');
    return parts[0].slice(2) + '.' + parts[1] + '.' + parts[2];
  }

  return (
    <ListContainer>
      <ListHeader>
        <HeaderCell $flex={1}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
            {t('statistics.table.colName')}
          </Text>
        </HeaderCell>
        <HeaderCell $width={70}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
            {t('statistics.table.colGender')}
          </Text>
        </HeaderCell>
        <HeaderCell $flex={1}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
            {t('statistics.table.colPhone')}
          </Text>
        </HeaderCell>
        <HeaderCell $width={100}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>
            {isRegisteredTab ? t('statistics.memberStatus.colRegDate') : t('statistics.memberStatus.colChurnDate')}
          </Text>
        </HeaderCell>
      </ListHeader>

      <ListDivisionLine />

      <ListBody $scrollBarColor={accentColor}>
        {members.map((member, index) => (
          <ListRow
            key={'MemberStatusList-' + index}
            $accentColorHover={accentColorHover}
            onClick={() => onClickMember(member.memberId)}>
            <BodyCell $flex={1}>
              <CellText fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text}>
                {member.name}
              </CellText>
            </BodyCell>
            <BodyCell $width={70}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>
                {member.gender === 'male' ? t('statistics.maleShort') : t('statistics.femaleShort')}
              </Text>
            </BodyCell>
            <BodyCell $flex={1}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>
                {calcPhone(member)}
              </Text>
            </BodyCell>
            <BodyCell $width={100}>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='pointer'>
                {isRegisteredTab ? formatIsoDate(member.startDate) : formatIsoDate(member.endDate)}
              </Text>
            </BodyCell>
          </ListRow>
        ))}
      </ListBody>
    </ListContainer>
  );
}

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
`;

const ListHeader = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  height: 30px;

  padding: 0 10px 0 10px;
`;

const HeaderCell = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  ${props => props.$flex ? `flex: ${props.$flex}; min-width: 0;` : ''}
  ${props => props.$width ? `width: ${props.$width}px; flex-shrink: 0;` : ''}

  overflow: clip;
`;

const ListDivisionLine = styled.div`
  width: 100%;
  height: 1px;

  opacity: 0.5;
  background-color: ${props => props.theme.line};

  margin: 0 0 0 0;
`;

const ListBody = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  max-height: 246px;

  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 50px;
    background-color: ${props => props.$scrollBarColor};
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
    border-radius: 200px;
  }
`;

const ListRow = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  padding: 9px 9px;

  width: calc(100% - 22px);

  border-radius: 5px;
  border: 1px solid ${props => props.theme.subBackground};
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    border: 1px solid ${props => props.$accentColorHover};
  }
`;

const BodyCell = styled.div`
  display: flex;
  flex-direction: row;

  align-items: center;

  ${props => props.$flex ? `flex: ${props.$flex}; min-width: 0;` : ''}
  ${props => props.$width ? `width: ${props.$width}px; flex-shrink: 0;` : ''}

  overflow: hidden;
`;

const CellText = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  min-width: 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;
